import { apiClient, Auth } from '@/shared/api'

import { TRoomSchedules } from '../model/schema'

export type HostRoomSchedulesParams = {
  roomId: number
}

export const getHostRoomSchedules = async ({
  roomId,
}: HostRoomSchedulesParams) => {
  const response = await apiClient.get<TRoomSchedules>({
    endpoint: `/host/rooms/${roomId}/schedules`,
    auth: Auth.REQUIRED,
  })

  return response
}
